import { render, staticRenderFns } from "./StudentChartStatus.vue?vue&type=template&id=33b25b3d&scoped=true"
import script from "./StudentChartStatus.vue?vue&type=script&lang=js"
export * from "./StudentChartStatus.vue?vue&type=script&lang=js"
import style0 from "./StudentChartStatus.vue?vue&type=style&index=0&id=33b25b3d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b25b3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b25b3d')) {
      api.createRecord('33b25b3d', component.options)
    } else {
      api.reload('33b25b3d', component.options)
    }
    module.hot.accept("./StudentChartStatus.vue?vue&type=template&id=33b25b3d&scoped=true", function () {
      api.rerender('33b25b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chartStatistical/StudentChartStatus.vue"
export default component.exports